import DocumentButton from "../../components/DocumentButton/DocumentButton";
import { useNavigate } from "react-router-dom";

import "./Error.scss";

export default function ErrorUI() {

    const navigate = useNavigate();

    function navigateToLogin() {
        navigate(`/login`);
    }

    return (<main className="error-container">
        <section className="empty">
        </section>
        <section className="button-container">
            <div>
                <DocumentButton text="Back to Login" loading={false} onClick={() => { navigateToLogin(); }} />
            </div>
        </section>
    </main>)
}